import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useEffect, useState } from 'react';

import CheckboxDot from '/@/components/checkbox-dot';

const RadioButtons = ({
    value,
    options,
    onChange,
    theme = 'cultivio',
    max = 1,
    className,
}: {
    value: string[];
    options: { label: string; value: string }[];
    onChange: (value: string[]) => void;
    theme?: string;
    max?: number;
    className?: string;
}) => {
    const [selectedCheckbox, setSelectedCheckbox] = useState({});
    const [selectedRadio, setSelectedRadio] = useState(undefined);

    useEffect(() => {
        if (max > 1) {
            setSelectedCheckbox(Object.assign({}, ...value.map((v) => ({ [v]: true }))));
        } else {
            setSelectedRadio(value);
        }
    }, [value]);

    const onChangeCheckbox = (ev) => {
        if (max > 1) {
            const newSelectedCheckbox = {
                ...selectedCheckbox,
                [ev.target.name]: ev.target.checked,
            };

            onChange(Object.keys(newSelectedCheckbox).filter((key) => newSelectedCheckbox[key]));
        }
    };

    const onChangeRadio = (v) => {
        if (max === 1) {
            onChange(v);
        }
    };

    if (max > 1) {
        // CHECKBOX
        const disabled = Object.keys(selectedCheckbox).length === max;
        return (
            <FormGroup row className={className}>
                {options.map((option, i) => (
                    <FormControlLabel
                        label={option.label}
                        key={i}
                        control={
                            <CheckboxDot
                                theme={theme}
                                checked={selectedCheckbox[option.value] | false}
                                onChange={onChangeCheckbox}
                                name={option.value}
                                disabled={disabled && !selectedCheckbox[option.value]}
                            />
                        }
                    />
                ))}
            </FormGroup>
        );
    }

    // RADIO
    return (
        <RadioGroup row aria-labelledby='demo-radio-buttons-group-label' name='radio-buttons-group'>
            {options.map((option, i) => (
                <FormControlLabel
                    value={option.value}
                    label={option.label}
                    onChange={(_) => onChangeRadio(option.value)}
                    key={i}
                    control={
                        <Radio
                            color='secondary'
                            checked={selectedRadio == option.value}
                            sx={{
                                padding: '12px',
                            }}
                        />
                    }
                />
            ))}
        </RadioGroup>
    );
};

export default RadioButtons;
